export default __webpack_public_path__ + "static/media/SV3.19bb6083.jpeg";